import {createMembershipCancelRequest} from './mutations/create-membership-cancel-request'
import {paySubscriptionBookingCyclesByOneTimePayment} from './mutations/create-subscription-booking-for-pay'
import {payNextSubscriptionCycle} from './mutations/pay-next-subscription-cycle'
import {updateSubscriptionPaymentMethod} from './mutations/update-subscription-payment-method'
import {withdrawMembershipCancelRequest} from './mutations/withdraw-membership-cancel-request'
import {getMembershipCancelRequests} from './queries/get-membership-cancel-requests'
import {getSubscriptionBooking} from './queries/get-subscription-booking'
import {getSubscriptionBookingsByMemberQuery} from './queries/get-subscription-bookings-by-member'

export const SubscriptionBookingsQueries = {
  getSubscriptionBookingsByMemberQuery,
  getSubscriptionBooking,
  getMembershipCancelRequests,
}

export const SubscriptionBookingsMutations = {
  paySubscriptionBookingCyclesByOneTimePayment,
  updateSubscriptionPaymentMethod,
  payNextSubscriptionCycle,
  createMembershipCancelRequest,
  withdrawMembershipCancelRequest,
}
